export default {
  de: {
    announcements: 'Ankündigungen',
    noAnnouncements: 'keine Ankündigungen vorhanden',
    newAnnouncement: 'Neue Ankündigung',
    submit: 'Veröffentlichen',
    notify: 'Email an Beauftragte senden?',
  },
};
